import React from 'react';
import { Switch, Form } from 'antd';

export const IsReturnForm = ({ onChange }) => {
  return (
    <div style={{ padding: '8px 24px 24px', borderTop: 'solid 1px #f4f4f4' }}>
      <p>
        A return order intends to <em>pick up</em> a package at the shopper&apos;s address, whereas a regular order{' '}
        <em>delivers</em> it.
      </p>
      <p>Toggling this switch will swap the pickup and return</p>

      <Form.Item label="Is Return" name="isReturn">
        <Switch onChange={onChange} />
      </Form.Item>
    </div>
  );
};
